import { getServerDateNow, NowReference } from '$/utils/serverDate';
import React from 'react';

export type ServerContextState = {
  serverDateNow: () => Date;
  setServerDate: (date: Date) => void;
};

export const ServerContext = React.createContext<ServerContextState>({} as ServerContextState);

export function useServerContext(): ServerContextState {
  return React.useContext(ServerContext);
}

/* React hook to return Date now function based on an initial server Date representing the server's current time */
export function useServerDateNow(serverNow: Date): () => Date {
  const nowReference = React.useMemo<NowReference>(() => {
    return { serverNow: serverNow, clientNow: new Date() };
  }, [serverNow]);

  return React.useCallback(() => {
    return getServerDateNow(nowReference);
  }, [nowReference]);
}
